export default __webpack_public_path__ + "static/media/SZ.f2cba9b2.svg";